import { render } from "./MigrateBanner.vue?vue&type=template&id=79a7ebe0&scoped=true&ts=true&lang=pug"
import script from "./MigrateBanner.vue?vue&type=script&lang=ts&setup=true"
export * from "./MigrateBanner.vue?vue&type=script&lang=ts&setup=true"

import "./MigrateBanner.vue?vue&type=style&index=0&id=79a7ebe0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79a7ebe0"]])

export default __exports__